import React from "react";
import cartIcon from "../../assets/img/add_to_card.png";
import { useCart } from "../../pages/CartContext";

const AddToCard = ({ product, quantity, openPopup, priceDisplay }) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const actualQuantity =
      priceDisplay === "per100" ? quantity * 100 : quantity;

    addToCart({ ...product, priceDisplay }, actualQuantity);

    if (typeof openPopup === "function") {
      openPopup(product, quantity); // pass the user's typed quantity
    }
  };

  return (
    <button
      onClick={handleAddToCart}
      className="plus text-lg p-2 bg-[#ef3f33] hover:bg-[#81d742] h-[35px] w-[58px] rounded-[0.2rem] flex items-center justify-center"
    >
      <img src={cartIcon} alt="Add to cart" className="h-[20px] w-[20px]" />
    </button>
  );
};

export default AddToCard;